import { DateTime } from "luxon";

export const getRangeMonth = (iso: string): number => DateTime.fromISO(iso, { zone: "utc" }).month;

export const isMonthInRange = (startMonth: string, endMonth: string, month: number): boolean => {
  const start = getRangeMonth(startMonth);
  const end = getRangeMonth(endMonth);
  if (Number.isNaN(start) || Number.isNaN(end)) return false;
  return start <= end ? month >= start && month <= end : month >= start || month <= end;
};

export const monthsUntilRange = (startMonth: string, month: number): number => {
  const start = getRangeMonth(startMonth);
  if (Number.isNaN(start)) return 12;
  return (start - month + 12) % 12;
};
